import { Check } from 'react-feather';
import { Trans, useTranslation } from 'react-i18next';
import { useContext } from 'react';
import styled, { css } from 'styled-components';

import { CookieConsentContext } from './CookieConsentProvider';
import UI from '../UI';
import useLocale from '../useLocale';

const Backdrop = styled.div`
  ${({ theme }) => css`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, .3);
    backdrop-filter: blur(3px);
    z-index: 1000;
    padding ${theme.gutter}px;
  `}
`;

const Container = styled(UI.Card)`
  max-width: 450px;

  ${UI.H3} {
    font-size: 1.2em;
  }
`;

const CookieConsentBar = () => {
  const { t } = useTranslation('common');
  const { locale } = useLocale();

  const { cookieConsent, acceptCookies, denyCookies } = useContext(CookieConsentContext);

  if (cookieConsent !== null) {
    return <></>;
  }

  return (
    <Backdrop>
      <Container>
        <UI.Paragraph sc={{ mb: 3 }}>
          <Trans i18nKey="common:cookie_consent.cookie_consent_warning">
            <UI.A
              href={`https://about.atleta.cc/${locale}/privacy`}
              target="_blank"
              rel="noopener noreferrer"
            />
          </Trans>
        </UI.Paragraph>
        <UI.GridContainer sc={{ columns: '1fr 1fr', gutter: 0.25 }}>
          <UI.Button
            onClick={() => denyCookies()}
            sc={{ mr: 1 }}
          >
            {t('cookie_consent.reject')}
          </UI.Button>
          {' '}
          <UI.Button
            onClick={() => acceptCookies()}
            sc={{ brand: 'primary.600' }}
          >
            <UI.Icon>
              <Check />
            </UI.Icon>
            {' '}
            <UI.Strong>{t('cookie_consent.accept')}</UI.Strong>
          </UI.Button>
        </UI.GridContainer>
      </Container>
    </Backdrop>
  );
};

export default CookieConsentBar;
